import { apiGet, apiPost, apiDelete, unwrap } from './apiClient';
import type { ResponseDTO } from '@/types/api';
import type { AppBookOrgUnit, AppBookAsset } from '@/types/appbook';

const BASE = '/api/v1/apple/appbook';

export async function listOrgUnits(): Promise<AppBookOrgUnit[]> {
  const res = await apiGet<ResponseDTO<AppBookOrgUnit[]>>(`${BASE}/org-units`, {
    includeTenantHeader: true,
  });
  return unwrap(res) ?? [];
}

export async function createOrgUnit(
  organisationUnit: string,
  tokenFile: File
): Promise<AppBookOrgUnit> {
  const form = new FormData();
  form.append('organisationUnit', organisationUnit);
  form.append('tokenFile', tokenFile);
  const res = await apiPost<ResponseDTO<AppBookOrgUnit>>(`${BASE}/org-unit`, form, {
    includeTenantHeader: true,
  });
  return unwrap(res);
}

export async function listAssets(orgUnitId: string): Promise<AppBookAsset[]> {
  const res = await apiGet<ResponseDTO<AppBookAsset[]>>(
    `${BASE}/org-unit/${encodeURIComponent(orgUnitId)}/assets`,
    { includeTenantHeader: true }
  );
  return unwrap(res) ?? [];
}

export async function deleteOrgUnit(orgUnitId: string): Promise<void> {
  await apiDelete<ResponseDTO<null>>(
    `${BASE}/org-unit/${encodeURIComponent(orgUnitId)}`,
    undefined,
    { includeTenantHeader: true }
  );
}
